import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectCurrentRunningPvPEventMapId } from "../../selectors/selectPVP";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TooltipText } from "../tooltip";
var _PVPUnitsAmount = React.memo(function (_a) {
    var units = _a.units, shouldRender = _a.shouldRender;
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "market-xp" },
        React.createElement(TooltipText, { id: IdLoca.bees },
            React.createElement(IconWithProgress, { progressPercent: 0, fillClassName: IdStyles.ProgressBarFill, iconStyle: IdStyles.IconLarge, backgroundClassName: IdStyles.StatBackground, icon: IdIcon.BeeIcn },
                React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: units })))));
});
var mapState = function (state) { return ({
    shouldRender: selectCurrentRunningPvPEventMapId(state) != undefined,
    units: state.pvp.unitAmount || Long.ZERO,
}); };
export var PVPUnitsAmount = connect(mapState)(_PVPUnitsAmount);



//////////////////
// WEBPACK FOOTER
// ./src/features/pvp/PVPUnitsAmount.tsx
// module id = 2848
// module chunks = 3